import { NOOP } from '../../utils/const.js';

function isEnterEvent(event) {
    return event && (event.keyCode === 13 || event.code === 'Enter');
}
function isArrowUpEvent(event) {
    return event && (event.keyCode === 38 || event.code === 'ArrowUp');
}
function isArrowDownEvent(event) {
    return event && (event.keyCode === 40 || event.code === 'ArrowDown');
}
function isTabEvent(event) {
    return event && (event.keyCode === 9 || event.code === 'Tab');
}
function isArrowLeftEvent(event) {
    return event && (event.keyCode === 37 || event.code === 'ArrowLeft');
}
function isArrowRightEvent(event) {
    return event && (event.keyCode === 39 || event.code === 'ArrowRight');
}
/**
 * Esegue la callback associata all'evento.
 */
class KeyboardEventDisparcher {
    constructor(event) {
        this.event = event;
    }
    on(matcher, callback) {
        if (matcher(this.event))
            callback();
        return this;
    }
    /**
     * Esegue `callback` alla pressione del tasto Enter.
     * @param {func} callback callback.
     */
    onEnter(callback = NOOP) {
        return this.on(isEnterEvent, callback);
    }
    /**
     * Esegue `callback` alla pressione del tasto Key Up.
     * @param {func} callback callback.
     */
    onUp(callback = NOOP) {
        return this.on(isArrowUpEvent, callback);
    }
    /**
     * Esegue `callback` alla pressione del tasto Key Down.
     * @param {func} callback callback.
     */
    onDown(callback = NOOP) {
        return this.on(isArrowDownEvent, callback);
    }
    /**
     * Esegue `callback` alla pressione del tasto Key Tab.
     * @param {func} callback callback.
     */
    onTab(callback = NOOP) {
        return this.on(isTabEvent, callback);
    }
    /**
     * Esegue `callback` alla pressione del tasto Key Left.
     * @param {func} callback callback.
     */
    onLeft(callback = NOOP) {
        return this.on(isArrowLeftEvent, callback);
    }
    /**
     * Esegue `callback` alla pressione del tasto Key Right.
     * @param {func} callback callback.
     */
    onRight(callback = NOOP) {
        return this.on(isArrowRightEvent, callback);
    }
}

export { KeyboardEventDisparcher, isArrowDownEvent, isArrowLeftEvent, isArrowRightEvent, isArrowUpEvent, isEnterEvent, isTabEvent };
